/**
 * Groups permissions by first part of permission.name
 * @param {Array} roles - Array of role objects with permissions
 * @returns {Array} Array of roles with permissionGroups added
 */
export const groupPermissionsByRole = (roles) => {
  if (!Array.isArray(roles)) {
    return []
  }

  return roles.map((role) => {
    const groups = {}
    if (Array.isArray(role.permissions)) {
      role.permissions.forEach((perm) => {
        if (!perm.name) {
          return
        }
        const [group] = perm.name.split('.')
        if (!groups[group]) {
          groups[group] = []
        }
        groups[group].push(perm)
      })
    }
    return {
      ...role,
      permissionGroups: groups,
    }
  })
}
